import { discountActionTypes } from '../actions/discountActions.js';
import { SERVICE_TYPE } from '../../../constant.js';

const initState = {
  discounts: {
    [SERVICE_TYPE.DELIVERY]: {},
    [SERVICE_TYPE.PICKUP]: {},
    [SERVICE_TYPE.SHUTTLE]: {},
  },
  discountsLoaded: {
    [SERVICE_TYPE.DELIVERY]: {},
    [SERVICE_TYPE.PICKUP]: {},
    [SERVICE_TYPE.SHUTTLE]: {},
  },
  discountsLoadFailed: {
    [SERVICE_TYPE.DELIVERY]: {},
    [SERVICE_TYPE.PICKUP]: {},
    [SERVICE_TYPE.SHUTTLE]: {},
  },
};

const handleLoadDiscounts = (state, action) => {
  const { restaurantIds, serviceType } = action;
  const discountsLoaded = {
    [serviceType]: {
      ...state.discountsLoaded[serviceType],
      ...restaurantIds.reduce(
        (acc, restaurantId) => ({ ...acc, ...{ [restaurantId]: false } }),
        {}
      ),
    },
  };
  const discountsLoadFailed = {
    [serviceType]: {
      ...state.discountsLoadFailed[serviceType],
      ...restaurantIds.reduce(
        (acc, restaurantId) => ({ ...acc, ...{ [restaurantId]: false } }),
        {}
      ),
    },
  };
  return {
    ...state,
    ...{
      discountsLoaded,
      discountsLoadFailed,
    },
  };
};

const handleLoadDiscountsSuccess = (state, action) => {
  const { restaurantIds, serviceType, discounts: loadedDiscounts } = action;
  const discounts = {
    ...state.discounts,
    ...{
      [serviceType]: {
        ...state.discounts[serviceType],
        ...loadedDiscounts,
      },
    },
  };
  const discountsLoaded = {
    ...state.discountsLoaded,
    ...{
      [serviceType]: {
        ...state.discountsLoaded[serviceType],
        ...restaurantIds.reduce(
          (acc, restaurantId) => ({ ...acc, ...{ [restaurantId]: true } }),
          {}
        ),
      },
    },
  };
  const discountsLoadFailed = {
    ...state.discountsLoadFailed,
    ...{
      [serviceType]: {
        ...state.discountsLoadFailed[serviceType],
        ...restaurantIds.reduce(
          (acc, restaurantId) => ({ ...acc, ...{ [restaurantId]: false } }),
          {}
        ),
      },
    },
  };
  return {
    ...state,
    ...{
      discounts,
      discountsLoaded,
      discountsLoadFailed,
    },
  };
};

const handleLoadDiscountsFailed = (state, action) => {
  const { restaurantIds, serviceType } = action;
  const discountsLoaded = {
    [serviceType]: {
      ...state.discountsLoaded[serviceType],
      ...restaurantIds.reduce((acc, restaurantId) => ({ ...acc, ...{ [restaurantId]: true } }), {}),
    },
  };
  const discountsLoadFailed = {
    [serviceType]: {
      ...state.discountsLoadFailed[serviceType],
      ...restaurantIds.reduce(
        (acc, restaurantId) => ({ ...acc, ...{ [restaurantId]: false } }),
        {}
      ),
    },
  };
  return {
    ...state,
    ...{
      discountsLoaded,
      discountsLoadFailed,
    },
  };
};

const DiscountReducer = (state = initState, action) => {
  switch (action.type) {
    case discountActionTypes.loadDiscounts:
      return handleLoadDiscounts(state, action);
    case discountActionTypes.loadDiscountsSuccess:
      return handleLoadDiscountsSuccess(state, action);
    case discountActionTypes.loadDiscountsFailed:
      return handleLoadDiscountsFailed(state, action);
    default:
      return state;
  }
};

export default DiscountReducer;
